import { stipAxios } from '../axios';

const logsEndpoints = {
    getAll: () => stipAxios.get(`/admin/logfile`),
};

export default logsEndpoints;
